import {HistoryEvent} from "./HistoryEvent";

export enum Outcome {
    correct,
    wrong,
    both
}

export class HistoryStats {

    public characterStats(knownCharacters: string, events: HistoryEvent[], desiredOutcome: Outcome, maxHistory: number = 1000): Map<string, number> {
        const characterStats = this.characterNumberMap(knownCharacters);

        events
            .slice(0, maxHistory)
            .filter((event) => {
                if (desiredOutcome == Outcome.both
                    || desiredOutcome == Outcome.correct && event.wasCorrect
                    || desiredOutcome == Outcome.wrong && !event.wasCorrect) {
                    return true;
                } else {
                    return false;
                }
            })
            .forEach((item) => {
                item.word.split('').forEach((char) => {
                    const current = characterStats.get(char) || 0;
                    characterStats.set(char, current + 1);
                });
            });

        return characterStats;
    }

    public lowestCorrect(knownCharacters: string, events: HistoryEvent[], maxHistory: number = 1000): [string[], number] {
        const stats = this.characterStats(knownCharacters, events, Outcome.correct, maxHistory);
        let min: number = 10000;
        let candidates: string[] = [];
        stats.forEach((occurences, char) => {
            if (occurences < min) {
                min = occurences;
                candidates = [char];
            } else if (occurences == min) {
                candidates.push(char);
            }
        });
        return [candidates, min]
    }

    public allCorrectNTimes(characters: string, requiredCorrectCount: number, history: HistoryEvent[]) {
        return this.lowestConsecutiveCorrect(characters, history)[0][1] >= requiredCorrectCount;
    }

    public lowestConsecutiveCorrect(knownCharacters: string, history: HistoryEvent[]): [string[], number][] {
        const characterMap = this.characterNumberMap(knownCharacters);
        const failedCharacters: string[] = [];
        history
            .sort((lhs, rhs) => lhs.index > rhs.index ? 1: -1)
            .reverse()
            .forEach((event) => {
               let characters = event.word.split('').filter((value, index, self) => self.indexOf(value) === index);
               if(event.wasCorrect) {
                       characters.forEach((char) => {
                       if(!failedCharacters.find((wrong) => { return char == wrong })) {
                           const current = characterMap.get(char) || 0;
                           characterMap.set(char, current + 1);
                       }
                   })
               } else {
                   characters.forEach((char) => {
                       if(!failedCharacters.find((wrong) => { return char == wrong })) {
                           failedCharacters.push(char);
                       }
                   })
               }
            });

        const counts: [number, string][] = [];
        characterMap.forEach((count, char) => {
            counts.push([count, char]);
        });
        const sortedCounts = counts.sort((lhs, rhs) => {
            if(lhs[0] < rhs[0]) {
                return -1
            } else {
                return 1;
            }
        });
        const grouped: [string[], number][] = [];
        let currentGroup: string[] = [];
        let currentCount = sortedCounts[0][0];
        sortedCounts.forEach((value) => {
            if(currentCount == value[0]) {
                currentGroup.push(value[1]);
            } else {
                grouped.push([currentGroup, currentCount]);
                currentCount = value[0];
                currentGroup = [value[1]];
            }
        });
        grouped.push([currentGroup, currentCount]);

        return grouped;
    }

    private characterNumberMap(knownCharacters: string) {
        return knownCharacters
            .split('')
            .reduce((agg: Map<string, number>, char: string, currentIndex: number, array: string[]) => {
                agg.set(char, 0);
                return agg
            }, new Map<string, number>());
    }
}


// WEBPACK FOOTER //
// ./src/HistoryStats.ts